import React from 'react'
import { Row } from 'antd'
import { CommunityResp } from 'types/community/community'

interface CommunityDetailsProps {
  community?: CommunityResp
}

const CommunityDetails: React.FC<CommunityDetailsProps> = ({ community }) => {
  return (
    <Row gutter={10} className="bg-grey container padding-top-10">
      <div className="profile_container">
        <h5 className="text-20 w-600">Community contacts</h5>
        <div className="mt-20px">
          <h4 className="text-12 grey-txt">Email</h4>
          <h4 className="text-14 w-500">{community?.email || 'NA'}</h4>
        </div>
        <div className="mt-20px">
          <h4 className="text-12 grey-txt">Phone</h4>
          <h4 className="text-14 w-500">
            {community?.phone
              ? `+${community.phone.dialCode} ${community.phone.number}`
              : 'NA'}
          </h4>
        </div>
        <div className="mt-20px">
          <h4 className="text-12 grey-txt">Website</h4>
          <h4 className="text-14 w-500">
            {community?.websiteUrl ? (
              <a
                href={community.websiteUrl}
                rel="noreferrer"
                className="prim-txt"
              >
                {community.websiteUrl}
              </a>
            ) : (
              'NA'
            )}
          </h4>
        </div>
        <div className="mt-20px">
          <h4 className="text-12 grey-txt">Custom link</h4>
          <h4 className="text-14 w-500">
            {community?.customUrl ? (
              <a
                href={community.customUrl}
                rel="noreferrer"
                className="prim-txt"
              >
                {community.customUrl}
              </a>
            ) : (
              'NA'
            )}
          </h4>
        </div>
      </div>
    </Row>
  )
}

export default CommunityDetails


